export default "__VITE_ASSET__BZuQ9Jyt__"